import styled from 'styled-components';
import media from '../../constants/media';

export const Wrapper = styled.div`
	display: flex;
	position: relative;
	align-items: center;
	justify-content: space-between;
	background-color: ${({ theme }) => theme.colors.white};
	border: 2px solid ${({ theme }) => theme.colors.primary};
	border-radius: 10px;
	padding: 5.1rem 7.1rem;
	flex-direction: column;

	${media.tablet`
		flex-direction: row;
	`};
`;

export const TextWrapper = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	width: unset;

	${media.tablet`
		width: 40%;
	`};
`;

export const Title = styled.div`
	font-family: ${({ theme }) => theme.fonts.ArimoMedium};
	color: ${({ theme }) => theme.colors.black};
	font-size: 4rem;
	font-weight: 700;
	margin-bottom: 3rem;
`;

export const Description = styled.div`
	margin-bottom: 2rem;
	font-family: ${({ theme }) => theme.fonts.ArimoRegular};
	font-size: 2.1rem;
	font-weight: 500;
	line-height: 3.1rem;
	color: ${({ theme }) => theme.colors.graySummary};
`;

export const TileLink = styled.a`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 1.6rem 6rem;
	margin-top: 2rem;
	background-color: ${({ theme }) => theme.colors.primary};
	font-size: 1.6rem;
	font-weight: 500;
	font-family: ${({ theme }) => theme.fonts.ArimoMedium};
	color: ${({ theme }) => theme.colors.white};
`;
